import PowerSupplyDto from './PowerSupplyDto'

export default class PowerSupplyAssignatedDto extends PowerSupplyDto {
    constructor(obj) {
        super(obj)
        this.siteCode = obj.siteCode
        this.situationDate = obj.situationDate
    }
}
